import moment from "moment";

const validateEmail = (email) => {
  const regExp =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regExp.test(email);
};

const validatePostalCode = (code) => {
  const regExp = /^\d+$/;
  if (regExp.test(code) && code.length === 5) {
    return true;
  }
  return false;
};

const validateDate = (date) => {
  const myDate = moment(date, "DD.MM.YYYY");
  return myDate.isValid() && myDate.isBefore();
};

export default { validateDate, validateEmail, validatePostalCode };
